import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EAuthenticateError, EAuthenticateStatus, ETwoFactorType } from '../../types/authentication';
import { AUTHENTICATION_AUTHENTICATE_TYPE } from '../../constants/action_types';
import { validate } from '../../api/validate';
import { jsonpRequest } from '../../../browser/utils/jsonpRequest';
import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { changeView } from '../view';
import { trackAuthenticateSuccess, trackTwoFactorAttemptsExhaustedPopupOpen, trackTwoFactorInvalid } from '../../utils/tracking';
import { isEmail } from '../../utils/validation';
export function authenticate(_ref) {
  var persistent = _ref.persistent,
      phone = _ref.phone,
      code = _ref.code;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, username, password, response, _response$response, logOnInfo, login, _error, isTwoFactoryByEmail, type, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                status: EAuthenticateStatus.Loading,
                type: AUTHENTICATION_AUTHENTICATE_TYPE
              });
              _getState = getState(), username = _getState.login, password = _getState.authentication.password;
              _context.prev = 2;
              _context.next = 5;
              return validate(context.httpApi, context.subdomain, {
                login: username,
                password: password,
                phone: phone,
                code: code
              });

            case 5:
              response = _context.sent;

              if (!(response.statusCode === 200)) {
                _context.next = 22;
                break;
              }

              _response$response = response.response, logOnInfo = _response$response.logOnInfo, login = _response$response.login;
              _context.prev = 8;
              _context.next = 11;
              return Promise.all(logOnInfo.map(function (info) {
                return jsonpRequest("".concat(info.logOnUrl, "?") + "login=".concat(encodeURIComponent(login), "&") + "token=".concat(info.token, "&") + "persistent=".concat(persistent || true));
              }));

            case 11:
              dispatch({
                status: EAuthenticateStatus.Succeed,
                type: AUTHENTICATION_AUTHENTICATE_TYPE
              });
              context.emitter.emit(EEventType.AuthenticateSucceed, {
                isTwoFactor: !!code
              });

              if (code) {
                trackAuthenticateSuccess(phone ? 'phone_code' : 'email_code');
              } else {
                trackAuthenticateSuccess(isEmail(username) ? 'email' : 'id');
              }

              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](8);
              dispatch({
                type: AUTHENTICATION_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                errorType: EAuthenticateError.Unexpected,
                error: 'Произошла непредвиденная ошибка'
              });

            case 19:
              return _context.abrupt("return");

            case 22:
              if (!(response.statusCode === 429)) {
                _context.next = 27;
                break;
              }

              dispatch({
                type: AUTHENTICATION_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                errorType: EAuthenticateError.LimitReached,
                error: 'Превышен лимит попыток авторизации. Попробуйте позже'
              });
              return _context.abrupt("return");

            case 27:
              if (!(response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(function (error) {
                return error.code.includes('needCheckCode');
              }))) {
                _context.next = 37;
                break;
              }

              _error = response.response.errors.find(function (error) {
                return error.code.includes('needCheckCode');
              });
              isTwoFactoryByEmail = Boolean(_error && _error.code === 'needCheckCodeByEmail');
              dispatch({
                type: AUTHENTICATION_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                errorType: EAuthenticateError.TwoFactorRequired,
                error: response.response.message
              }); // Для пользователей с виртуальными номерами, сразу отображаем экран ввода кода подтверждения

              if (isTwoFactoryByEmail) {
                dispatch(changeView(EActiveView.TwoFactorWithEmail));
              } else {
                dispatch(changeView(EActiveView.TwoFactor));
              }

              type = isTwoFactoryByEmail ? ETwoFactorType.Email : ETwoFactorType.Sms;
              context.emitter.emit(EEventType.TwoFactorRequired, {
                type: type
              });
              return _context.abrupt("return");

            case 37:
              if (!(response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(function (error) {
                return error.code === 'invalidConfirmationCode';
              }))) {
                _context.next = 42;
                break;
              }

              context.emitter.emit(EEventType.TwoFactorInvalid);
              trackTwoFactorInvalid(!phone ? ETwoFactorType.Email : ETwoFactorType.Sms);
              _context.next = 48;
              break;

            case 42:
              if (!(response.statusCode === 400 && response.response.errors.length > 0 && response.response.errors.some(function (error) {
                return error.code === 'confirmationCodeInputLimitReached';
              }))) {
                _context.next = 48;
                break;
              }

              dispatch({
                type: AUTHENTICATION_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                errorType: EAuthenticateError.TwoFactorAttemptsExhausted,
                error: response.response.message
              });
              dispatch(changeView(EActiveView.TwoFactorAttemptsExhausted, {
                phone: phone
              }));
              context.emitter.emit(EEventType.TwoFactorAttemptsExhausted, {
                phone: phone
              });
              trackTwoFactorAttemptsExhaustedPopupOpen(!phone ? ETwoFactorType.Email : ETwoFactorType.Sms);
              return _context.abrupt("return");

            case 48:
              error = response.response.errors.length > 0 ? response.response.errors[0].message : response.response.message;
              dispatch({
                type: AUTHENTICATION_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                errorType: EAuthenticateError.Common,
                error: error
              });
              _context.next = 56;
              break;

            case 52:
              _context.prev = 52;
              _context.t1 = _context["catch"](2);
              context.logger.error(_context.t1);
              dispatch({
                type: AUTHENTICATION_AUTHENTICATE_TYPE,
                status: EAuthenticateStatus.Failed,
                errorType: EAuthenticateError.Unexpected,
                error: 'Произошла непредвиденная ошибка'
              });

            case 56:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 52], [8, 16]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}